import React from 'react'
import { Placeholder } from 'react-bootstrap';

import './styles.css'

// define um card pequeno para ser usado em um produto
const LargeCardPlaceholder = () => {
    return (
        <Placeholder as="p" animation="wave" className="large-card-container">
            <Placeholder xs={12} className="large-card-description placeholder-color" />
            <Placeholder xs={12} className="placeholder-color" />
            <Placeholder xs={12} className="placeholder-large-know placeholder-color" />
        </Placeholder>
    );
}

export default LargeCardPlaceholder;
